export const englishSpeakingCountries = {
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  AU: 'Australia',
  NZ: 'New Zealand',
  IE: 'Ireland',
  ZA: 'South Africa',
  NG: 'Nigeria',
  KE: 'Kenya',
  GH: 'Ghana',
  IN: 'India',
  PH: 'Philippines',
  PK: 'Pakistan',
  SG: 'Singapore',
  MY: 'Malaysia',
  BZ: 'Belize',
  JM: 'Jamaica',
  TT: 'Trinidad and Tobago',
  BB: 'Barbados',
  BS: 'Bahamas',
  ZW: 'Zimbabwe',
  BW: 'Botswana',
  NA: 'Namibia',
  FJ: 'Fiji',
  PG: 'Papua New Guinea',
  SL: 'Sierra Leone',
  GM: 'Gambia',
  LR: 'Liberia',
  MT: 'Malta',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  GD: 'Grenada',
  GY: 'Guyana',
};

export const isEnglishSpeakingCountry = (data) => {
  if (!data) return false;
  return englishSpeakingCountries[data?.country] || englishSpeakingCountries[data?.countryCode]
    ? true
    : false;
};

export const staticLocationsFromSearch = [
  {
    description: 'San Francisco (Bay Area, CA, USA)',
    matched_substrings: [
      {
        length: 7,
        offset: 0,
      },
    ],
    place_id: 'ChIJtdeIpqODhYARqR9GV4QbiYw',
    reference: 'ChIJtdeIpqODhYARqR9GV4QbiYw',
    structured_formatting: {
      main_text: 'Bay Area',
      main_text_matched_substrings: [
        {
          length: 7,
          offset: 0,
        },
      ],
      secondary_text: 'CA, USA',
    },
    terms: [
      {
        offset: 0,
        value: 'Bay Area',
      },
      {
        offset: 10,
        value: 'CA',
      },
      {
        offset: 14,
        value: 'USA',
      },
    ],
    types: ['political', 'geocode', 'colloquial_area'],
  },
  {
    description: 'Ciudad de México, CDMX, Mexico',
    matched_substrings: [
      {
        length: 9,
        offset: 0,
      },
    ],
    place_id: 'ChIJB3UJ2yYAzoURQeheJnYQBlQ',
    reference: 'ChIJB3UJ2yYAzoURQeheJnYQBlQ',
    structured_formatting: {
      main_text: 'Ciudad de México',
      main_text_matched_substrings: [
        {
          length: 9,
          offset: 0,
        },
      ],
      secondary_text: 'CDMX, Mexico',
    },
    terms: [
      {
        offset: 0,
        value: 'Ciudad de México',
      },
      {
        offset: 18,
        value: 'CDMX',
      },
      {
        offset: 24,
        value: 'Mexico',
      },
    ],
    types: ['geocode', 'locality', 'political'],
  },
  {
    description: 'Querétaro, Qro., Mexico',
    matched_substrings: [
      {
        length: 9,
        offset: 0,
      },
    ],
    place_id: 'ChIJVZJb3I9b04URL4MbVqqUsJc',
    reference: 'ChIJVZJb3I9b04URL4MbVqqUsJc',
    structured_formatting: {
      main_text: 'Querétaro',
      main_text_matched_substrings: [
        {
          length: 9,
          offset: 0,
        },
      ],
      secondary_text: 'Qro., Mexico',
    },
    terms: [
      {
        offset: 0,
        value: 'Querétaro',
      },
      {
        offset: 11,
        value: 'Qro.',
      },
      {
        offset: 17,
        value: 'Mexico',
      },
    ],
    types: ['geocode', 'locality', 'political'],
  },
];
